import React from "react";
import QuestionsBuilder from "../../../screening/QuestionsBuilder";

const FORM_LINK_TOKEN = "{{form_link}}";

/**
 * Wizard step 1 (when screening is on) — the screening form builder. Reuses the existing
 * QuestionsBuilder wholesale (library + custom questions + per-question qualifying answer);
 * this file only supplies the wizard chrome around it and turns on the library search box.
 * The sequence name + "Include screening" toggle live in the shell's SetupBar above this.
 */
const StepQuestions = ({ questions, currency, onQuestionsChange, onCurrencyChange }) => (
    <div className="flex flex-col">
        <h1 className="text-lg font-light text-left dark:text-white text-textPrimary mb-6">
            What questions do you want the candidate to answer?
        </h1>
        <QuestionsBuilder
            questions={questions}
            onChange={onQuestionsChange}
            currency={currency}
            onCurrencyChange={onCurrencyChange}
            showLibrarySearch
            variant="wizard"
        />
    </div>
);

export default StepQuestions;
